class ImageUtils {

    static tintImage(image, tintColor) {

        let canvas = document.createElement('canvas');
        canvas.width = image.width();
        canvas.height = image.height();
        
        let fg = new Image();
        fg.onload = function() {

            let buffer = document.createElement('canvas');
            buffer.width = fg.width;
            buffer.height = fg.height;

            let bx = buffer.getContext('2d');
            bx.fillStyle = tintColor;
            bx.fillRect(0,0,buffer.width,buffer.height);
            bx.globalCompositeOperation = "destination-atop";
            bx.drawImage(fg,0,0);

            let ctx = canvas.getContext('2d');
            ctx.drawImage(fg,0,0);
            ctx.globalAlpha = 1;
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(buffer,0,0,canvas.width,canvas.height);

            image[0].src = canvas.toDataURL();
        };
        fg.src = image[0].src;

    }

}